import NeighborhoodsPage from './neighborhoods-page';
export default NeighborhoodsPage;